import React from 'react';
import { Modal } from 'react-bootstrap';

interface ModalSemAnexoProps {
    show: boolean;
    onHide: () => void;
    tituloOportunidade: string;
}

const ModalSemAnexo: React.FC<ModalSemAnexoProps> = ({
    show,
    onHide,
    tituloOportunidade
}) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Body>
                <div className="text-center">
                    <div className="avatar avatar-xl bg-warning-light rounded-circle mb-3">
                        <i className="ti ti-alert-triangle fs-36 text-warning" />
                    </div>
                    <h4 className="mb-2">Não é possível mover a oportunidade</h4>
                    <p className="mb-3">
                        A oportunidade "{tituloOportunidade}" não possui anexos. É necessário adicionar pelo menos um anexo antes de mudar de etapa.
                    </p>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onHide}
                    >
                        Entendi
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ModalSemAnexo;